/*
 * @Author: Chao Yang
 * @Date: 2019-12-12 01:30:01
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-03-24 01:35:44
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Cancel, HttpHeaderHandler, ResultHandler } from './http';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpHeaderHandler,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Cancel,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ResultHandler,
      multi: true
    }
  ]
})
export class InterceptorModule {}
